import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { DetailedQuote } from '../../../../../domain/public-api';
import { IconFlagComponent } from '../../../../../components/icon/icon-flag.component';
import { CurrencyPipe } from '../../../../../pipes/currency.pipe';
import { TodaysChangeComponent } from '../../todays-change/todays-change.component';
import { QuoteIssueType } from '../../domain/quote-issue-type.enum';

@Component({
  selector: 'td-wb-detailed-quote-summary-symbol-detail',
  templateUrl: './detailed-quote-summary-symbol-detail.component.html',
  styleUrls: ['./detailed-quote-summary-symbol-detail.component.scss'],
  imports: [
    IconFlagComponent,
    CurrencyPipe,
    TodaysChangeComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetailedQuoteSummarySymbolDetailComponent {

  @Input() quote: DetailedQuote;
  @Input() displayName: boolean = true;
  @HostBinding('attr.role') readonly role: string = 'listitem';
  isMutualFund(): boolean {
    return this.quote.issueType === QuoteIssueType.MF;
  }

}
